(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function init() {
    var targets = document.querySelectorAll(
      '.gng-card, .gng-section-title, .gng-viewall, .gng-banner__cta, .gng-newsletter__title, .gng-newsletter__text, .gng-newsletter__form'
    );
    if (!targets.length) return;
    var counters = new WeakMap();
    targets.forEach(function (el) {
      el.classList.add('gng-reveal');
      var parent = el.parentElement;
      var i = counters.get(parent) || 0;
      counters.set(parent, i + 1);
      el.style.transitionDelay = (i % 6) * 55 + 'ms';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    targets.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
